import { render, staticRenderFns } from "./passwordForgotten.vue?vue&type=template&id=655612cc&"
import script from "./passwordForgotten.vue?vue&type=script&lang=js&"
export * from "./passwordForgotten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports